import React from 'react'
import { Helmet, MetaProps } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

interface Props {
  title: string
  lang?: string
  meta?: MetaProps[]
  description?: string
}

export default function SEO({
  title,
  description,
  meta = [],
  lang = 'zh-CN',
}: Props) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, user-scalable=no',
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        ...meta,
      ]}
    >
      <script type="application/ld+json">
        {`
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "3分钟获取个性化套餐",
        "item": "https://www.corplaw.ai/cn/question"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "了解报价",
        "item": "https://www.corplaw.ai/cn/package"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "美国公司法干货博客",
        "item": "https://blog.corplaw.ai"
      }]
    }
    `}
      </script>
    </Helmet>
  )
}
